<script lang="ts">
import { onMountedOrActivated } from "@/core/hooks/onMountedOrActivated";
import { ref, computed, reactive, defineComponent, toRefs, onMounted, watch } from "vue";
import store from "@/store";
import downImg  from "@/assets/images/down-circle.png"
import downImgGreen  from "@/assets/images/down-circle-green.png"
export default defineComponent({
  name: "PrintItem",
  components: {},
  props: {
    item: {
      type: Object,
    },
  },
  setup(props, { emit }) {
    const state = reactive({
      flg:(props.item as any).collapsed,
      collapsed:(props.item as any).collapsed,
      disabled:(props.item as any).disabled,
    })
    const themeName=computed(() => store.state.theme.themeName);
    watch(()=>props.item,(n,o)=>{
      state.flg = (props.item as any).collapsed;
      state.disabled =  (props.item as any).disabled;
      state.collapsed = (props.item as any).collapsed;
    },{immediate:true,deep:true})
    const clickHeader=()=>{
      if(!state.flg){
        state.collapsed = !state.collapsed;
      }
    }
    onMountedOrActivated(()=>{
      // console.log("🚀 ~ file: header.vue:31 ~ onMountedOrActivated ~ ssss:", "PrintItem")

    })
    return {
      ...toRefs(state),
      clickHeader,
      themeName,
      downImgGreen,
      downImg
    };
  },
});
</script>
<template>
  <div class="ub ub-ver fw print-item">
    <div class="ub ub-ac ub-ps fw print-header" @click="clickHeader">
      <div class="mask" v-if="disabled"></div>
      <img
        :src="themeName=='green'?downImgGreen:downImg"
        class="header-icon"
        :class="collapsed ? 'translat180' : 'translat0'"
      />
      <slot name="header"></slot>
    </div>
    <div class="ub fw print-content" :class="collapsed ? 'collapsed' : ''">
      <slot name="body"></slot>
    </div>
  </div>
</template>
<style scoped lang="less">
.print-item {
  padding: 0px 16px;
  box-sizing: border-box;
  background-color: #fff;
}
.print-header {
  height: 36px;
  line-height: 36px;
  padding-left: 16px;
  box-sizing: border-box;
  background-color: #fafafa;
  border: 1px solid #dcdee2;
  border-top: none;
  cursor: pointer;
  font-weight: bold;
}
.header-icon {
  width: 14px;
  height: 14px;
  margin-right: 10px;
  font-size: 14px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #2f2f2f;
}
.print-content {
  height: 100%;
  padding: 10px;
  box-sizing: border-box;
  background-color: #fff;
  border: 1px solid #dcdee2;
  border-top: none;
  flex-wrap: wrap;
  :deep(.ant-form-item) {
    width: 33.33%;
    padding-right: 16px;
    box-sizing: border-box;
  }
  :deep(.col6) {
    width: 25% !important;
  }
  :deep(.col8) {
    width: 33.33% !important;
  }
  :deep(.col12) {
    width: 50% !important;
  }
  :deep(.col16) {
    width: 66.67% !important;
  }
  :deep(.col24) {
    width: 100% !important;
  }
}
:deep(.ant-card-body) {
  padding: 0;
}
:deep(.ant-card-bordered) {
  border: none;
}
:deep(.ant-form-item-control) {
  min-width: 170px !important;
}

.collapsed {
  height: 0;
  transition: all 0.1s ease-in;
  overflow: hidden;
  padding: 0;
  border-bottom: none;
}
.translat180 {
  transform: rotate(180deg);
  transition: all 0.1s ease-in;
}
.translat0 {
  transform: rotate(0deg);
  transition: all 0.1s ease-in;
}
.mask {
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  z-index: 10;
  background-color: rgba(0, 0, 0, 0.06);
  cursor: not-allowed;
}
</style>
